import React, { useCallback, useState } from "react";
import {
  DocumentData,
  DocumentSnapshot,
  QueryDocumentSnapshot,
} from "firebase/firestore";
import { Box, HStack, Pressable } from "native-base";
import { useSignatureProofs } from "../../../hooks/useSignatureProofs.web";
import PhotoThumbnail from "../../shared/PhotoThumbnail";
import PhotoModal from "../capture/PhotoModal";

type Props = {
  object: DocumentSnapshot<DocumentData>;
};

export default function SignatureProofThumbnails({ object }: Props) {
  const [photoInModal, setPhotoInModal] = useState<
    QueryDocumentSnapshot<DocumentData> | undefined
  >(undefined);

  const onClose = useCallback(() => setPhotoInModal(undefined), []);

  const [signatureProofs] = useSignatureProofs(
    object.ref.parent.parent!.id,
    object.id
  );

  if (signatureProofs.length === 0) {
    return null;
  }

  return (
    <>
      <HStack space={2} flexWrap="wrap">
        {signatureProofs.map((doc) => (
          <Box key={doc.id} w="200" h="150" mb={2}>
            <Pressable onPress={() => setPhotoInModal(doc as any)}>
              <PhotoThumbnail photo={doc as any} />
            </Pressable>
          </Box>
        ))}
      </HStack>

      <PhotoModal
        objectName="Unterschrift"
        photo={photoInModal}
        onClose={onClose}
      />
    </>
  );
}
